function firstLetterUpper(theString) {
  const safeString = String(theString != null ? theString : '').trim()
  if (!safeString) return ''
  var newString = safeString.toLowerCase().replace(/(^\s*\w|[\.\!\?]\s*\w)/g,function(c){return c.toUpperCase()});
  return newString;
}

export const toSentenceCase = (str) => {
  var theString = str
  var newString = firstLetterUpper(theString);
  return newString;
}

export const capitalize = (str, lower = false) => {
  const safeString = String(str != null ? str : '')
  return (lower ? safeString.toLowerCase() : safeString).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase())
}

export const normalizeText = (value) =>
  String(value != null ? value : '')
    .trim()
    .toLowerCase()

export const capitalizeEachWord = (str) =>
  String(str != null ? str : '')
    .trim()
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

export const parseProfessionalName = (str) => capitalizeEachWord(str)

export const orderBy = (array, key) => {
  return [...array].sort((a, b) => {
    if (a[key] < b[key]) return -1
    if (a[key] > b[key]) return 1
    return 0
  })
}

export const getMultiDisplayText = (values, options = [], summary) => {
  if (!Array.isArray(values) || values.length === 0) return ''
  if (summary && summary.threshold != null && values.length > summary.threshold) {
    const firstOption = options.find(opt => opt.value === values[0])
    const firstLabel = firstOption ? firstOption.label : values[0]
    return `${firstLabel} + ${values.length}`
  }
  const labels = values
    .map(val => {
      const option = options.find(opt => opt.value === val)
      return option ? option.label : val
    })
    .filter(label => label != null && label !== '')
  return labels.join(', ')
}
